import {
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Tooltip
} from '@mui/material';
import React from 'react';
import { OrderButton } from './style';
import { Link } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import Row from './Row';
import { useState } from 'react';

const EntradaTabela = ({ allEntrada, setAllEntrada, selectedEntrada, getEntradas, page, rowsPerPage, handleClickOpenEdit }) => {
    const [orderById, setOrderById] = useState('desc');
    const [orderByNome, setOrderByNome] = useState('desc');

    const handleSortById = () => {
        const sortedEntrada = [...allEntrada].sort((a, b) => {
            if (orderById === 'desc') {
                return b.id - a.id;
            } else {
                return a.id - b.id;
            }
        });

        setAllEntrada(sortedEntrada);
        setOrderById(orderById === 'asc' ? 'desc' : 'asc');
    };

    const handleSortByNome = () => {
        const sortedEntrada = [...allEntrada].sort((a, b) => {
            const nomeA = a.numero_documento.toUpperCase();
            const nomeB = b.numero_documento.toUpperCase();

            if (orderByNome === 'desc') {
                if (nomeA < nomeB) return -1;
                if (nomeA > nomeB) return 1;
            } else {
                if (nomeA > nomeB) return -1;
                if (nomeA < nomeB) return 1;
            }

            return 0;
        });

        setAllEntrada(sortedEntrada);
        setOrderByNome(orderByNome === 'asc' ? 'desc' : 'asc');
    };

    return (
        <TableContainer
            component={Paper}
            sx={{
                maxHeight: '300px'
            }}
        >
            <Table sx={{ minWidth: 650 }} aria-label="simple table" stickyHeader>
                <TableHead>
                    <TableRow>
                        <OrderButton>
                            <TableSortLabel onClick={handleSortById} direction={orderById === 'asc' ? 'desc' : 'asc'}>
                                <b>ID</b>
                            </TableSortLabel>
                        </OrderButton>
                        <OrderButton align="center">
                            <TableSortLabel onClick={handleSortByNome} direction={orderByNome === 'asc' ? 'desc' : 'asc'}>
                                <b>Número documento</b>
                            </TableSortLabel>
                        </OrderButton>
                        <TableCell align="center">
                            <b>Ações</b>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {allEntrada.length > 0 &&
                        allEntrada
                            .filter((entrada) =>
                                selectedEntrada ? entrada.numero_documento.includes(selectedEntrada.numero_documento) : true
                            )
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((item) => (
                                <Row key={item.id} item={item} getEntradas={getEntradas} handleClickOpenEdit={handleClickOpenEdit} />
                            ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default EntradaTabela;
